export const alarmName = "pd:ping_schedule";
export const intervalKey = "pd_ping_interval";
export const partnerExtensionIdsKey = "partnerExtensionIds";
export const lastPingKey = "pd_last_ping";
export const uboDetectedKey = "uboDetected";
export const uboDetectionLastRunKey = "uboDetectionLastRun";
export const PingMessage = {
    type: "ping",
};
export const PartnerExtensionIds = [
    "cfhdojbkjhnklbpkdaibdccddilifddb",
    "gighmmpiobklfepjocnamgkkbiglidom",
    "gmgoamodcdcjnbaobigkjelfplakmdhh",
    "ndcileolkflehcjpmjnfbnaibdcgglog",
    "oidhhegpmlfpoeialbgcdocjalghfpkp",
    "{d10d0bf8-f5b5-c8b4-a8b2-2b9879e08c5d}",
    "jid1-NIfFY2CA8fy1tg@jetpack",
];
export const uboExtensionIds = [
    "cjpalhdlnbpafiamejdnhcphjbkeiagm",
    "ddkjiahejlhfcafbddmgiahcphecmpfh",
    "odfafepnkmbhccpbejgmiehpchacaeak",
    "cimighlppcgcoapaliogpjjdehbnofhn",
    "kccohkcpppjjkkjppopfnflnebibpida",
    "99f80bf7-2581-4e03-a191-3013e8d65551",
];
